import { render, staticRenderFns } from "./NormalSearchNav663.vue?vue&type=template&id=5af90fc2&scoped=true"
import script from "./NormalSearchNav663.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav663.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af90fc2",
  null
  
)

export default component.exports